var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"authors"}},_vm._l((_vm.sortedAuthors),function(author){return _c('div',{key:author.id,staticClass:"tag",on:{"click":function($event){return _vm.selectAuthor(author)}}},[_vm._v("\n\t\t"+_vm._s(author.title)+"\n\t")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }